import { createFileRoute, redirect } from '@tanstack/react-router';

// Password managers (iOS, Chrome, 1Password…) send "Change password" to this well-known URL rather
// than guessing a site's own page (https://w3c.github.io/webappsec-change-password-url/). Without
// it the tap lands on the 404. The password card sits on the profile page's Security tab; a
// logged-out visitor is walked through login and back there by the app shell.
export const Route = createFileRoute('/.well-known/change-password')({
	beforeLoad: () => {
		throw redirect({ to: '/settings/profile', search: { tab: 'security' }, replace: true });
	},
});
